
import { Component, Prop, Vue } from 'vue-property-decorator';

import Subtitle from '../atoms/Subtitle.vue';

@Component({
  components: {
    Subtitle,
  },
})
export default class TasksStateHeader extends Vue {
  @Prop([]) readonly title!: string;

  @Prop([]) readonly count!: number | string;
}
